// This file was generated using `pay js:run gql-v1 --type=fragment --name=LegalEntityAddressArk --dir=path/to/dir`.
// To generate yours, do not copy and paste; use the command above instead. Do not delete this comment.

/* eslint-disable @stripe-internal/data-v1/camel-case-alias */

import {gql} from '@sail/data';

import type {GraphQlDocument} from '@sail/data';
import type {Exact} from '@stripe-internal/data-v1/schema/types';

import type {V1PermissionToken} from '@stripe-internal/data-v1/types';

const doc = gql`
  fragment LegalEntityAddressArkFragment on OpenapiLegalEntityAddress {
    city
    country
    line1
    line2
    line3
    line4
    town
    postal_code
    state
  }
`;

export const legalEntityAddressArkFragment: LegalEntityAddressArkFragmentDocument =
  doc;

// THIS IS AUTOGENERATED CODE, DO NOT EDIT AS YOUR CHANGES WILL BE BLOWN AWAY
// Regenerate it using eslint in fix mode.

export type LegalEntityAddressArkFragmentData = {
  readonly __typename: 'OpenapiLegalEntityAddress';
  readonly city: string | null;
  readonly country: string | null;
  readonly line1: string | null;
  readonly line2: string | null;
  readonly line3: string | null;
  readonly line4: string | null;
  readonly town: string | null;
  readonly postal_code: string | null;
  readonly state: string | null;
};

export type LegalEntityAddressArkFragmentVariables = Exact<{
  [key: string]: never;
}>;

const legalEntityAddressArkFragmentPermissions = {} as const;

doc.permissions = legalEntityAddressArkFragmentPermissions;

export type LegalEntityAddressArkFragmentPermissions = V1PermissionToken<
  typeof legalEntityAddressArkFragmentPermissions
>;

export type LegalEntityAddressArkFragmentDocument = GraphQlDocument<
  LegalEntityAddressArkFragmentData,
  LegalEntityAddressArkFragmentVariables,
  LegalEntityAddressArkFragmentPermissions
>;
